import {Injectable, OnDestroy} from '@angular/core';
import {ReportComponentRepository} from '../ngrx/reportComponent.repository';
import {ReportComponentSummaryDataServiceAdapter} from '../ngrx/reportComponentSummaryDataService.adapter';
import {Operator, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {
    ReportComponentDefinitionType
} from '../../../../report-component-definition/api/entity/reportComponentDefinition.model';
import {ReportComponentSummaryAbstractFindAllService} from './reportComponentSummaryAbstractFindAll.service';

@Injectable()
export class ReportComponentSummaryHeaderFindAllService extends ReportComponentSummaryAbstractFindAllService
    implements OnDestroy{

    public constructor(repository: ReportComponentRepository, dataServiceAdapter: ReportComponentSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter, [
            new UrlParameter('definition.type.value', ReportComponentDefinitionType.HEADER, Operator.EQUALS)
        ]);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
